export enum ReasonCode {
    MD5 = 'MD5_CHECK',
    FORMAT_BLACKLISTED = 'FILE_FORMAT_CHECK.BLACKLISTED',
    FORMAT_UNKNOWN = 'FILE_FORMAT_CHECK.UNKNOWN',
    VIRUS = 'VIRUS_CHECK.VIRUS'
}
